import { render, staticRenderFns } from "./ProductsSimpleList.vue?vue&type=template&id=0a0a5832&scoped=true&"
import script from "./ProductsSimpleList.vue?vue&type=script&lang=js&"
export * from "./ProductsSimpleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a5832",
  null
  
)

export default component.exports